import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CouponsAPI } from '../../../../api/payments/coupons/api';

export function useCouponDetailsBootstrap(couponId, initialCoupon) {
  const history = useHistory();
  const [coupon, setCoupon] = useState(initialCoupon ?? null);
  const [confirmAction, setConfirmAction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchingCoupon, setFetchingCoupon] = useState(false);

  useEffect(() => {
    if (coupon || !couponId) return;
    setFetchingCoupon(true);
    CouponsAPI.get(couponId)
      .then((response) => setCoupon(response.data))
      .catch(() => {})
      .finally(() => setFetchingCoupon(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponId]);

  const goToEdit = () => {
    history.push({
      pathname: `/payments/coupons/${couponId}/edit`,
      state: { coupon },
    });
  };

  const goToList = () => history.push('/payments/coupons');

  const handleExpire = async () => {
    setLoading(true);
    try {
      const expiresAt = new Date().toISOString();
      await CouponsAPI.update(couponId, {
        code: coupon.code,
        externalId: coupon.externalId,
        active: false,
        cyclesCount: coupon.cyclesCount,
        expiresAt,
      });
      setCoupon((prev) => ({ ...prev, active: false, expiresAt }));
      toast.success('Cupom expirado com sucesso!');
    } catch (error) {
      // erro já exibido via toast pela função de api
    } finally {
      setLoading(false);
      setConfirmAction(null);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await CouponsAPI.delete(couponId);
      toast.success('Cupom excluído com sucesso!');
      history.push('/payments/coupons');
    } catch (error) {
      // erro já exibido via toast pela função de api
    } finally {
      setLoading(false);
      setConfirmAction(null);
    }
  };

  return {
    coupon,
    confirmAction,
    setConfirmAction,
    loading,
    fetchingCoupon,
    goToEdit,
    goToList,
    handleExpire,
    handleDelete,
  };
}
